var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('h1',{staticClass:"text-pagename text-xs-center"},[_vm._v("Wallet")]),_c('walletTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }